import { ProductInput } from '@/models/Import'

// export const getProductInputEntries = (productInputBysku: { [currentSku: string]: ProductInput } | undefined) => {
//   return Object.entries(productInputBysku || {}).filter(([, productInput]) => {
//     const containsChanges =  !!Object.keys(productInput || {}).reduce((sum) => {
//       sum += Object.keys(productInput || {}).length
//       return sum
//     }, 0)

//     return containsChanges || !!Object.keys(productInput.propertyStatuses || {}).length
//   })
// }

export const getProductInputEntries = (productInputBysku: { [currentSku: string]: ProductInput } | undefined) => {
  return Object.entries(productInputBysku || {}).filter(([, productInput]) => !!Object.keys(productInput || {}).length)
}

// export const mappingUsesWrapper = (value: string | number | undefined) => !!(value && /^{{.*}}$/.test(value?.toString()))
export const mappingUsesWrapper = (value: string | number | undefined) => typeof value === 'string' && value.startsWith('{{') && value.endsWith('}}')
